import React, { useEffect, useState } from 'react';
import { Select as AndtSelect } from 'antd';
import { Associative } from '../../../types';
import { useClient, useUser } from '../../../contexts';
import { ALERT_TYPES, CUSTOMER_TYPES } from '../../../constants';

interface SelectProps {
  id: string;
  name: string;
  placeholder: string;
  defaultValue: string;
  options: Associative[];
  isDisabled?: boolean;
  dropdownStyle?: {};
  mode?: 'multiple' | 'tags' | undefined;
}

const DATA_SOURCE_URL_MAPPER: Associative = {
  category: '/categories?type=solidarity',
  alertType: '/categories?type=alert',
  parentGroup: '/me/groups?per_page=2000',
};

export const Select: React.FC<SelectProps> = ({
  id,
  name,
  placeholder,
  defaultValue,
  options,
  isDisabled,
  mode,
  dropdownStyle,
}) => {
  const { get } = useClient();
  const { user } = useUser();

  const [optionsValues, setOptionsValues] = useState<Array<Associative>>([]);

  const dataSourceUrl = DATA_SOURCE_URL_MAPPER[name] || '';

  useEffect(() => {
    dataSourceUrl &&
      get<any>(dataSourceUrl, ({ data }) => {
        data &&
          setOptionsValues(
            data.reduce(
              (optionsData: any, option: Associative) => ({
                ...optionsData,
                [option.id]:
                  name === 'alertType'
                    ? ALERT_TYPES[option.display_name]?.displayName
                    : name === 'parentGroup'
                    ? option.name
                    : option.display_name,
              }),
              {}
            )
          );
      });
  }, [dataSourceUrl, name, get]);

  // Les options statiques du champ complètent celles du data source (ex :
  // parent courant d'une sous-communauté, absent de /me/groups) — la version
  // fraîchement chargée garde la priorité sur le libellé.
  let selectOptions = dataSourceUrl
    ? { ...((options as unknown as Associative) || {}), ...optionsValues }
    : options;
  if (name === 'category') {
    let otherCategory: any = [];
    Object.entries(selectOptions).forEach(category => {
      if (Object.values(category)[1] === 'Autre') otherCategory = category;
    });

    const filteredCategories = Object.entries(selectOptions).filter(
      c => Object.values(c)[1] !== 'Autre'
    );

    const sortedCategories = filteredCategories.sort((a, b) => {
      return Object.values(a)[1] > Object.values(b)[1] ? 1 : -1;
    });

    selectOptions = [...sortedCategories, otherCategory];

    const filteredCategoriesForNational = selectOptions.filter(
      categorie =>
        categorie[1] !== "Aide en cas d'absence" &&
        categorie[1] !== 'Cours et aide aux devoirs' &&
        categorie[1] !== 'Autre'
    );

    selectOptions =
      user && user.customer.type === CUSTOMER_TYPES.NATIONAL
        ? filteredCategoriesForNational
        : selectOptions;
  }

  if (name === 'category') {
    return (
      <AndtSelect
        placeholder={placeholder}
        size="large"
        id={id}
        defaultValue={defaultValue}
        disabled={isDisabled}
        mode={mode}
        dropdownStyle={dropdownStyle}
      >
        {selectOptions &&
          selectOptions.map(v => {
            return (
              <AndtSelect.Option key={v[0]} value={v[0]}>
                {v[1]}
              </AndtSelect.Option>
            );
          })}
      </AndtSelect>
    );
  } else {
    return (
      <AndtSelect
        placeholder={placeholder}
        size="large"
        id={id}
        defaultValue={defaultValue}
        disabled={isDisabled}
        mode={mode}
        dropdownStyle={dropdownStyle}
      >
        {name === 'parentGroup' && (
          <AndtSelect.Option key="detach" value="detach">
            <>aucun groupe parent</>
          </AndtSelect.Option>
        )}
        {selectOptions &&
          Object.entries(selectOptions).map(([key, value]) => (
            <AndtSelect.Option key={key} value={key}>
              <>{value}</>
            </AndtSelect.Option>
          ))}
      </AndtSelect>
    );
  }
};
